import '../style/main.css';
import Meta from '../components/Meta.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Accordion from '../components/Accordion.js';
import ResourceButton from '../components/ResourceButton.js';
function Resources() {
  return (
		<>
			<Meta title='Resources'/>
			<Header />
			<div class='main-content'>
				<h2>Resources</h2>
				<h3>Documents</h3>
				<ResourceButton
					title="Borealis Blades Historical Fencing Waiver"
					description="Click to view the waiver as a PDF"
					url="/documents/BBHF Waiver.pdf"
				/>

				<h3>HEMA Research & Communities</h3>
				<ResourceButton
					title='Wiktenauer'
					description='Collection of primary sources, data, and information relevant to HEMA and Western Martial Arts'
					url='https://wiktenauer.com/'
				/>

				<ResourceButton
					title='HEMA Bookshelf'
					description='The publisher primarily focuses on the production of HEMA books, translations, and facsimiles'
					url='https://www.hemabookshelf.com/'
				/>

				<ResourceButton
					title='Meyer Freifechter Guild'
					description='Facebook group of the Meyer Freifechter Guild'
					url='https://www.facebook.com/freyfechter/'
				/>

				<h3>Trusted Vendors and Manufacturers</h3>
				<ResourceButton
					title='Purpleheart Armoury'
					description='Texas-based vendor of HEMA equipment from a variety of manufacturers'
					url='https://www.woodenswords.com/'
				/>

				<ResourceButton
					title='Arms & Armor'
					description='Minnesota-based historical weapons manufacturer focusing on accurate reproductions'
					url='https://www.arms-n-armor.com/'
				/>

				<ResourceButton
					title='Albion Swords'
					description='Wisconsin-based sword manufacturer with a variety of historical and reimagined weapon designs'
					url='https://albion-swords.com/'
				/>

				<ResourceButton
					title='VB Swordshop'
					description='Historical weapons manufacturer by swordsmith Viktor Berbekucz'
					url='https://www.swordsviktor.com/'
				/>

				<ResourceButton
					title='Sigi Forge'
					description='Slovakian-based historical weapons manufacturer'
					url='https://sigiforge.com/'
				/>

				<ResourceButton
					title='Sparring Glove'
					description='HEMA glove designs driven by data'
					url='https://sparringglove.com/en/'
				/>

				<ResourceButton
					title='Histfenc'
					description='Manufacturer of SPES protective equipment and more'
					url='https://histfenc.eu/en/'
				/>

				<h3>HEMA YouTube Channels</h3>
				<ResourceButton
					title='Scholagladiatoria'
					description="Matt Easton's historical channel covering military time periods from the medieval to Victorian and WW1 eras"
					url='https://www.youtube.com/@scholagladiatoria'
				/>

				<ResourceButton
					title='Arms & Armor Inc.'
					description='YouTube channel of the historical weapons manufacturer Arms & Armor'
					url='https://www.youtube.com/@armsarmorinc.4153'
				/>

				<ResourceButton
					title='Björn Rüther'
					description='Historical Fencer Björn Rüther shares tips and techniques about HEMA'
					url='https://www.youtube.com/c/Bj%C3%B6rnR%C3%BCther'
				/>

				<ResourceButton
					title='Robert Rutherfoord'
					description='Channel focusing on the German rapier traditions'
					url='https://www.youtube.com/@RobertRutherfoord'
				/>

				<ResourceButton
					title='The Historical Fencing Channel'
					description='A synergistic channel of historical fencing groups with the goal of finding common ground and building a collaborative community'
					url='https://www.youtube.com/@thehistoricalfencingchanne7899'
				/>

				<ResourceButton
					title='Schildwache Potsdam'
					description='Channel dedicated to the research and teaching of 16th-century Bolognese sources'
					url='https://www.youtube.com/@SchildwachePotsdam'
				/>
			</div>
			
			<Footer />  
		</>
	);
};

export default Resources;
